export const siteServer = (site) => {
  const user = site.runAsUser?.trim();
  return user ? `${site.server}~${encodeURIComponent(site._id)}~${encodeURIComponent(user)}` : site.server;
};

export const splitServer = (value) => {
  const [server, siteId, user, ...extra] = String(value || "").split("~");
  if (!server || extra.length || (siteId === undefined) !== (user === undefined))
    throw new Error("Invalid server context");
  return {
    server,
    siteId: siteId === undefined ? undefined : decodeURIComponent(siteId),
    runAsUser: user === undefined ? "" : decodeURIComponent(user),
  };
};

export default { siteServer, splitServer };
